import { ref } from 'vue'

import { usePortalStore } from '@/stores/portal.store'

export const buildTagPayload = (name, values = {}, existingTranslations = null) => {
  const language = usePortalStore().selectedLanguage
  const defaultLanguage = window.config.DEFAULT_LANGUAGE
  const translations = { ...existingTranslations, [language]: { name } }
  if (language !== defaultLanguage && !existingTranslations?.[defaultLanguage]) translations[defaultLanguage] = { name }
  return { translations, ...values }
}

export const useTagDraft = (createAsync) => {
  const tagDraft = ref(null)
  const openTagDraft = (name, done) => { tagDraft.value = { name, done } }
  const confirmTagDraftAsync = async(tag) => {
    const id = await createAsync(tag)
    tagDraft.value.done(id, 'add-unique')
    tagDraft.value = null
  }
  return { tagDraft, openTagDraft, confirmTagDraftAsync }
}
